@if (searchService.search_loading || searchParams.isLoadingSSO) {
  <app-loading-screen [animated]="animated" icon="ico-rail" aria-hidden="true">
    <span title i18n="@@railloading_title">Just loading your search results</span>
    @if (searchParams.airportExpressStation) {
      <div msgOne>
        {{ searchParams.airportExpressStation | airportExpress }}
      </div>
    }
    @if (!searchParams.airportExpressStation) {
      <div msgOne>
        <span i18n="@@railloading_msgOne">Trains for</span>
        {{ searchParams.travellingFrom.name | titlecase }}
        <span i18m="@@railloading_from">to</span>
        {{ searchParams.travellingTo.name | titlecase }}
      </div>
    }
    <span msgTwo i18n="@@railloading_msgTwo">Checking for availability</span>
  </app-loading-screen>
}
